import { Form } from '../core'

$.fn.BookingWidget_Dropdown = function(tab) {
  let self = this

  if (self.data('booking-widget-dropdown')) {
    return self.data('booking-widget-dropdown')
  }

  self.id = self.attr('id')

  self.initialize_interface = function() {
    /* Do not click on links inside any dropdown */
    self.find('a').on('click', function(e) {
      e.preventDefault()
    })

    /* Close button */
    self.find('.booking-widget__dropdown__close').on('click', function() {
      tab.close()
    })

    /* Destinations radio buttons */
    let locationChoice = self.find('input[name="location_choice"]')
    locationChoice.on('change', function() {
      self.find('.card-locator-item').removeClass('card-locator-item--highlighted')
      let locationCard = self.find('.card-locator-item[data-name="' + $(this).val() + '"]'),
      locationName = locationCard.find('.card-locator-item__title').html()
      locationCard.addClass('card-locator-item--highlighted')
      tab.addClass('booking-widget__selected--populated')
      tab.find('.booking-widget__value').text(locationName).attr('title', locationName)
      if ($.mlmi.mobile.isMobile) {
        tab.close()
      }
    })

    /* Date range picker */
    if (self.id == 'dates-dropdown') {
      let date_picker = self.DateRangePicker()
      date_picker.on('dates_changed', function(e, dates) {
        let dateString = date_picker.get_date_string(dates.start_date)
        tab.bar.find('input[name="date_start"]').val(dateString)
        if (dates.end_date != undefined && dates.end_date) {
          dateString += ' – ' + date_picker.get_date_string(dates.end_date)
          tab.bar.find('input[name="date_end"]').val(date_picker.get_date_string(dates.end_date))
          if ($.mlmi.mobile.isMobile) {
            tab.close()
          }
        } else {
          tab.bar.find('input[name="date_end"]').val('')
        }
        tab.addClass('booking-widget__selected--populated')
        tab.find('.booking-widget__value').text(dateString).attr('title', dateString)
      })

      /* Clone fields */
      tab.bar.find('input[name="date_start"]').prop('disabled', true)
      tab.bar.find('input[name="date_end"]').prop('disabled', true)
      self.find('.date-picker-indicator').append(tab.bar.find('.field-container--date_start').clone())
      self.find('.date-picker-indicator').append(tab.bar.find('.field-container--date_end').clone())
    }

    /* Promo field */
    if (self.find('input[name="widget-promo-code"]').length) {
      self.find('button[name="widget-promo-confirm"]').on('click', function() {
        requestAnimationFrame(self.clicked_outside)
      })
      self.find('input[name="widget-promo-code"]').on('keydown', function(e) {
        if (e.keyCode == 9 || e.keyCode == 13) {
          self.clicked_outside()
        }
      })
    }
  }

  self.opened = function() {
    /* Promo field */
    if (self.find('input[name="widget-promo-code"]').length) {
      setTimeout(function() {
        self.find('input[name="widget-promo-code"]').get(0).focus()
      }, 100)
    }
  }

  self.closed = function() {
    /* Promo field */
    if (self.find('input[name="widget-promo-code"]').length) {
      if (self.find('input[name="widget-promo-code"]').val()) {
        let promoString = self.find('input[name="widget-promo-code"]').val()
        tab.addClass('booking-widget__selected--populated')
        tab.find('.booking-widget__value').text(promoString).attr('title', promoString)
        tab.bar.find('input[name="promo_code"]').val(promoString)
      } else {
        tab.removeClass('booking-widget__selected--populated')
        tab.find('.booking-widget__value').text('').attr('title', '')
        tab.bar.find('input[name="promo_code"]').val('')
      }
    }
  }

  self.clicked_outside = function(e) {
    if (e != undefined) {
      if ($(e.target).hasClass('ui-datepicker-next') || $(e.target).hasClass('ui-datepicker-prev') || $(e.target).hasClass('ui-icon')) {
        return
      }
      if ($(e.target).hasClass('booking-widget__dropdown') || $(e.target).closest('.booking-widget__dropdown').length) {
        return
      }
    }
    tab.close()
  }

  self.calculate_mobile = function() {
    self.show()
    self.data('targetHeight', self.outerHeight(false))
    if (self.attr('aria-hidden') === 'true') {
      self.hide()
    }
  }

  self.is_mobile = function() {
    self.clicked_outside()
    $(window).on('resize load orientationchange', self.calculate_mobile)
    self.calculate_mobile()
  }

  self.is_desktop = function() {
    self.clicked_outside()
    $(window).off('resize load orientationchange', self.calculate_mobile)
    setTimeout(function() {
      tab.dropdown.css('display', '')
    }, 300)
  }

  return function() {
    self.initialize_interface()
    self.data('booking-widget-dropdown', self)
    $.mlmi.mobile.add(self.is_mobile, self.is_desktop)
    return self
  }()
}

$.fn.BookingWidget_Tab = function(bar) {
  let self = this

  if (self.data('booking-widget-tab')) {
    return self.data('booking-widget-tab')
  }

  self.bar = bar
  self.opened = false
  self.dropdown = undefined

  self.clicked = function() {
    if (self.opened) {
      self.close()
    } else {
      self.open()
      bar.close_tabs(self)
    }
  }

  self.open = function() {
    if (self.dropdown != undefined) {
      self.opened = true
      self.attr('aria-expanded', 'true')
      self.dropdown.attr('aria-hidden', 'false')
      self.dropdown.opened()
      requestAnimationFrame(function() {
        $(document).on('click', self.dropdown.clicked_outside)
      })
      if ($.mlmi.mobile.isMobile) {
        self.dropdown.slideDown({
          duration: self.dropdown.data('targetHeight') > 300 ? 550 : 300,
          easing: 'easeInOutQuart',
          delay: 250,
        })
      }
    }
  }

  self.close = function() {
    if (self.dropdown != undefined) {
      self.opened = false
      self.attr('aria-expanded', 'false')
      self.dropdown.attr('aria-hidden', 'true')
      self.dropdown.closed()
      $(document).off('click', self.dropdown.clicked_outside)
      if ($.mlmi.mobile.isMobile) {
        $('html, body').scrollTo(0, 250, 999, 'easeInOutQuart')
        self.dropdown.slideUp({
          duration: 250,
          easing: 'easeInOutQuart',
        })
      }
    }
  }

  return function() {
    self.dropdown = $('#' + self.attr('aria-controls')).BookingWidget_Dropdown(self)
    self.on('click', self.clicked)
    self.data('booking-widget-tab', self)
    return self
  }()
}

$.fn.BookingWidget_ScrollManager = function() {
  let self = this

  self.header = $('.header')
  self.original_holder = self.parent()
  self.header_holder = self.header.find('.header__widget-holder')

  self.status = {
    in_header: false,
    header_expanded: false,
    cutoff: 999,
  }

  self.set_cutoff = function() {
    self.status.cutoff = $.mlmi.mobile.isMobile ? $('.booking-widget').offset().top + $('.booking-widget').outerHeight(false) + 50 : 180
  }

  self.scrolled = function(top, direction) {
    if (top >= self.status.cutoff && direction == 'down' && !self.status.in_header) {
      self.status.in_header = true
      if (!$.mlmi.mobile.isMobile) {
        if (window.innerWidth <= 989) {
          self.header_holder.append(self.detach())
        } else {
          self.header_holder.append(self.detach().hide().fadeIn(250))
        }
      }
      $('body').addClass('--holds-widget')
    } else if (top >= self.status.cutoff && direction == 'up' && !self.status.header_expanded) {
      self.status.header_expanded = true
      $('body').addClass('--header-expanded')
    } else if (top < self.status.cutoff && direction == 'up' && self.status.in_header) {
      self.status.in_header = false
      if (!$.mlmi.mobile.isMobile) {
        self.original_holder.append(self.detach().hide().fadeIn(250))
      }
      $('body').removeClass('--holds-widget')
    }
    if (!self.status.in_header) {
      self.status.header_expanded = false
      $('body').removeClass('--header-expanded')
    } else if (direction == 'down' && self.status.header_expanded) {
      self.status.header_expanded = false
      $('body').removeClass('--header-expanded')
    }
  }

  self.button_clicked = function() {
    if ($.mlmi.mobile.isMobile) {
      $('html, body').scrollTo(0, 250, 9999, 'easeInOutQuart')
    } else {
      self.status.header_expanded = true
      $('body').addClass('--header-expanded')
    }
  }

  return function() {
    $.mlmi.mobile.add(function() {
      self.set_cutoff()
    }, function() {
      self.set_cutoff()
    })
    $(window).ScrollEvents().add(self.scrolled)
    $('.header__widget-holder__button').on('click', self.button_clicked)
    return self
  }()
}

$.fn.BookingWidget = function() {
  let self = this

  if (self.data('booking-widget')) {
    return self.data('booking-widget')
  }

  self.tabs = []
  self.form = undefined
  self.submit_button = self.find('.booking-widget__action')

  self.close_tabs = function(except) {
    self.tabs.forEach(function(tab) {
      if (except == undefined) {
        tab.close()
      } else if (!except.is(tab)) {
        tab.close()
      }
    })
  }

  return function() {
    self.find('.booking-widget__selected').each(function() {
      let tab = $(this).BookingWidget_Tab(self)
      self.tabs.push(tab)
    })
    self.form = new Form(self.find('.booking-widget-form'), {
      onSubmit: function() {
        self.form.getForm().enable_fields()
      },
    })
    self.submit_button.on('click', function() {
      self.form.getForm().trigger('submit')
    })
    self.BookingWidget_ScrollManager()
    self.data('booking-widget', self)
    return self
  }()
}
